import { PRIZE_MODAL_PRODUCTS_COUNT } from '../constants'
import {
  extractCatalogEntityId,
  normalizeCatalogRedirectUrl,
} from '../utils/catalog-url'
import { filterInStockProducts } from '../utils/prize-modal-products'

const logRequestError = (gaApp, error, { name, message }) => {
  if (error?.aborted) {
    throw error
  }

  gaApp.services.app.rejection.log({
    name,
    message,
    errorData: error,
  })
}

export class ApiService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  /**
   * Товары по SKU. Возвращает только позиции с inStock === true.
   */
  async fetchProductsBySku(skuArray = [], requestOptions = {}) {
    const addressParams = this.gaApp.services.main.user.addressParams

    const params = {
      itemIds: skuArray.map((item) => item.toString()),
      ...addressParams,
    }

    try {
      const { data } =
        await this.gaApp.repositories.product.main.fetchProductsBySku(
          params,
          requestOptions,
        )

      return filterInStockProducts(data.products || [])
    } catch (error) {
      logRequestError(this.gaApp, error, {
        name: 'product:fetch-products-by-sku',
        message: 'Ошибка при получении подборки продуктов',
      })

      return []
    }
  }

  /**
   * Товары категории. Возвращает только позиции с inStock === true.
   */
  async fetchCatalogProductsByCategoryId(
    categoryId,
    limit = PRIZE_MODAL_PRODUCTS_COUNT,
    requestOptions = {},
  ) {
    const addressParams = this.gaApp.services.main.user.addressParams

    const params = {
      categoryId,
      pageSize: limit * 2,
      ...addressParams,
    }

    try {
      const { data } =
        await this.gaApp.repositories.product.main.fetchCatalogProducts(
          params,
          requestOptions,
        )

      const products = data?.products || data?.items || []

      return filterInStockProducts(products)
    } catch (error) {
      logRequestError(this.gaApp, error, {
        name: 'product:fetch-catalog-products',
        message: 'Ошибка при получении продуктов по категории',
      })

      return []
    }
  }

  /**
   * Догрузка товаров по productsLink (redirect → products).
   * Не бросает ошибку — при сбое возвращает [].
   * Возвращает только позиции с inStock === true.
   */
  async fetchSupplementProductsByLink(
    productsLink,
    { excludeItemIds = [], limit = PRIZE_MODAL_PRODUCTS_COUNT } = {},
    requestOptions = {},
  ) {
    const url = normalizeCatalogRedirectUrl(productsLink)

    if (url === '') return []

    try {
      const { data } = await this.gaApp.services.app.api.getRedirectData(
        { url },
        requestOptions,
      )

      const categoryId = extractCatalogEntityId(data)

      if (categoryId == null || categoryId === '') return []

      const products = await this.fetchCatalogProductsByCategoryId(
        categoryId,
        limit,
        requestOptions,
      )

      const exclude = new Set(excludeItemIds)

      return products
        .filter((product) => !exclude.has(product.itemId))
        .slice(0, limit)
    } catch (error) {
      logRequestError(this.gaApp, error, {
        name: 'product:fetch-supplement-products-by-link',
        message: 'Ошибка при догрузке продуктов по productsLink',
      })

      return []
    }
  }
}
